import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../klanten/AllKlanten.css';

function AllKlanten() {
    const [klanten, setKlanten] = useState([]);
    const [zoekterm, setZoekterm] = useState('');
    const [filteredKlanten, setFilteredKlanten] = useState([]);
    const token = sessionStorage.getItem('jwtToken');

    axios.defaults.withCredentials = true;

    const normalizeFeatures = (features) => {
        if (!features) return {};

        if (typeof features === 'string') {
            try {
                return JSON.parse(features);
            } catch {
                return {};
            }
        }

        if (typeof features === 'object') return features;

        return {};
    };

    const hasPrivateLessons = (klant) => {
        const features = normalizeFeatures(klant.features);
        return features.private_lessons === true || features.private_lessons === 'true';
    };

    const fetchKlanten = useCallback(async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/customer/allCustomers`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                }
            );

            setKlanten(Array.isArray(response.data.data) ? response.data.data : []);
        } catch (error) {
            console.error('Fout bij ophalen klanten:', error);
            setKlanten([]);
        }
    }, [token]);

    useEffect(() => {
        fetchKlanten();
    }, [fetchKlanten]);

    const handleDelete = async (id) => {
        if (!window.confirm('Weet je zeker dat je deze klant wilt verwijderen?')) return;

        try {
            await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/customer/deleteCustomer/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            fetchKlanten();
            alert('Klant succesvol verwijderd!');
        } catch (error) {
            console.error('Fout bij verwijderen klant:', error);
        }
    };

    useEffect(() => {
        const filtered = klanten.filter((klant) => {
            const text = [
                klant.name,
                klant.email,
                klant.contact_firstname,
                klant.contact_lastname,
                klant.phone,
                klant.address
            ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();

            return text.includes(zoekterm.toLowerCase());
        });

        setFilteredKlanten(filtered);
    }, [zoekterm, klanten]);

    return (
        <div className="all-student">
            <span>
                <i className="h1">Overzicht Van Alle Klanten</i>
            </span>

            <div className="text-center">
                <Link
                    to="/klant/nieuw"
                    style={{ cursor: 'pointer', color: 'green', fontSize: '48px' }}
                    className="bi bi-plus-circle-dotted"
                    title="Nieuwe klant"
                ></Link>
            </div>

            <div className="mb-3">
                <input
                    type="text"
                    className="form-control rounded-0"
                    placeholder="Zoek op klant naam, e-mail, contactpersoon of adres"
                    value={zoekterm}
                    onChange={(e) => setZoekterm(e.target.value)}
                />
            </div>

            <div className="table-responsive">
                <table className="table table-striped table-bordered">
                    <thead className="table-light">
                        <tr>
                            <th>Klant nummer</th>
                            <th>Naam Klant</th>
                            <th>Contact Voornaam</th>
                            <th>Contact Achternaam</th>
                            <th>Contact Mobiel</th>
                            <th>Email</th>
                            <th>Telefoon</th>
                            <th>Adres</th>
                            <th>Privélessen</th>
                            <th>Acties</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredKlanten.map((klant) => (
                            <tr key={klant.customer_id}>
                                <td>{klant.customer_id}</td>
                                <td>{klant.name}</td>
                                <td>{klant.contact_firstname}</td>
                                <td>{klant.contact_lastname}</td>
                                <td>{klant.contact_mobile}</td>
                                <td>{klant.email}</td>
                                <td>{klant.phone}</td>
                                <td>{klant.address}</td>
                                <td>
                                    {hasPrivateLessons(klant) ? (
                                        <span className="badge bg-success">Aan</span>
                                    ) : (
                                        <span className="badge bg-secondary">Uit</span>
                                    )}
                                </td>
                                <td>
                                    <Link
                                        to={`/klant/edit/${klant.customer_id}`}
                                        id="edit_button"
                                        className="btn btn-sm btn-warning me-2 rounded-0"
                                        style={{ fontSize: '10px', padding: '2px 5px' }}
                                    >
                                        Bewerk
                                    </Link>
                                    <button
                                        onClick={() => handleDelete(klant.customer_id)}
                                        className="btn btn-sm btn-danger rounded-0"
                                        style={{ fontSize: '10px', padding: '2px 5px' }}
                                    >
                                        Verwijder
                                    </button>
                                </td>
                            </tr>
                        ))}

                        {filteredKlanten.length === 0 && (
                            <tr>
                                <td colSpan="10" className="text-center">
                                    Geen klanten gevonden.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AllKlanten;
